import React from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {PostTypes} from 'features/postGenerator/constants';
import {setPostTypeAC} from 'features/postGenerator/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import Slider from 'react-slick';

import './PostTypeSlider.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function PostTypeSlider() {
  const dispatch = useSetGlobalState();
  const {postType} = useGlobalState((state) => state.postGenerator);

  const isPostActive = (typeOfPost: keyof typeof PostTypes) => {
    return typeOfPost === postType ? 'post-type-slider__button--active' : '';
  };

  return (
    <div>
      <div className="post-type-slider">
        <Slider
          speed={300}
          slidesToShow={5}
          slidesToScroll={1}
          centerPadding="50"
          dots={false}
          arrows={false}
          infinite={false}
          draggable
        >
          <div className="post-type-slider__item">
            <Button
              className={`post-type-slider__button post-type-slider__button--portrait ${isPostActive(
                'instagramPortrait',
              )}`}
              onClick={() => {
                dispatch(setPostTypeAC('instagramPortrait'));
              }}
            >
              <Icon icon="instagramWhite" />
              <p>4:5</p>
            </Button>
            <p>Instagram Portrait</p>
          </div>
          <div className="post-type-slider__item">
            <Button
              className={`post-type-slider__button post-type-slider__button--square ${isPostActive('instagramSquare')}`}
              onClick={() => {
                dispatch(setPostTypeAC('instagramSquare'));
              }}
            >
              <Icon icon="instagramWhite" />
              <p>1:1</p>
            </Button>
            <p>Instagram Square</p>
          </div>
          <div className="post-type-slider__item">
            <Button
              className={`post-type-slider__button post-type-slider__button--story ${isPostActive('instagramStory')}`}
              onClick={() => {
                dispatch(setPostTypeAC('instagramStory'));
              }}
            >
              <Icon icon="instagramWhite" />
              <p>9:6</p>
            </Button>
            <p>Instagram Story</p>
          </div>
          <div className="post-type-slider__item">
            <Button
              className={`post-type-slider__button post-type-slider__button--tv ${isPostActive('pubTV')}`}
              onClick={() => {
                dispatch(setPostTypeAC('pubTV'));
              }}
            >
              <Icon icon="tv-icon" />
            </Button>
            <p>Pub&apos;s TV Post</p>
          </div>
          <div className="post-type-slider__item">
            <Button
              className={`post-type-slider__button post-type-slider__button--facebook ${isPostActive(
                'facebookTimeline',
              )}`}
              onClick={() => {
                dispatch(setPostTypeAC('facebookTimeline'));
              }}
            >
              <Icon icon="fb-icon" />
            </Button>
            <p>Facebook post</p>
          </div>
        </Slider>
      </div>
    </div>
  );
}
